module.exports = __webpack_public_path__ + "static/고추장간장-248006cceb692527c93fe636d69a9057.png";